import Input from './input';
import Button from './button';
import Divider from './divider';
import MovieListArrowLeft from './movieListArrowLeft';
import MovieListArrowRight from './movieListArrowRight';

export default {
	Input,
	Button,
	Divider,
	MovieListArrowLeft,
	MovieListArrowRight
};
